import { Title, Container } from '@mantine/core';
import Breadcrumbs from 'components/BreadcrumbsComponent';
import CoursePlanForm from 'components/forms/lcms/CoursePlanForm';
import React, { useEffect } from 'react';
import { pathnames } from 'routes/lcms';
import { useCoursePlanStore } from 'store/createCoursePlan';

const CreateCoursePlan = () => {
  const { mode, reset, setFormMode } = useCoursePlanStore();

  useEffect(() => {
    reset();
    setFormMode('add');
  }, [reset, setFormMode]);

  const breadcrumbs = [
    { title: 'Course Planning', href: pathnames.coursePlan },
    { title: mode === 'add' ? 'New Course Plan' : 'Edit Course Plan', href: '' }
  ];

  return (
    <Container fluid>
      <Breadcrumbs items={breadcrumbs} mb={32} />

      <Title order={2} mb={30}>
        {mode === 'add' ? 'Create New' : 'Edit'} Course Plan
      </Title>

      <CoursePlanForm />
    </Container>
  );
};

export default CreateCoursePlan;
